<template>
  <div>
    <el-dialog title="答题说明"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :append-to-body="true"
               width="800rem"
               margin-top="282rem"
               :before-close="handleClose">
      <div class="text_warp">
        <p>  1.本系统支持提前设置做卷时间，请在考试开始前完成设置，系统将在规定时间内自动提交。</p>
          <p>  2.选择题请点击选项方框，系统自动保存。</p><p>3.多选题、填空题和解答题请在自备纸张上填写题号和相应答案，确保字迹清晰、区域对应。</p><p>4.完成试卷后进入答题卡页面，拍摄答案照片(最多只能上传6张照片，每张照片不超过10M)，检查清晰度和完整性后上传。</p><p>5.确认无误后，点击提交答案；提交后不可修改，请谨慎操作。</p>
      
      </div>
      <div class="text_warp1" v-if=" this.$route.query.type!=4 || this.$route.query.flag=='AI' ">
        <p style="text-align: center;font-weight: 600;">批改设置 </p>
        <div   style="display: flex; font-weight: 400;
font-size: 24rem; margin-top: 39rem;">
          <div style="margin-right: 166rem">将试卷设置为自评  </div>
           <div style="margin-top: 4rem;"><el-checkbox-group v-model="checkedType"
                               @change="handleChangeType">
              <el-checkbox label="true" style="margin-right: 116rem;">是</el-checkbox>
              <el-checkbox label="false">否</el-checkbox>

            </el-checkbox-group></div>
        
        </div>
      </div>
      <div class="text_warp1">
        <p style="text-align: center;font-weight: 600;">做卷时间 </p>
        <div v-if=" JSON.parse(this.$route.query.form).paper_duration>0" style="display: flex;justify-content: center;font-weight: 400;
font-size: 24rem; margin-top: 39rem;">
          <div > 请在
   <span style="margin: 0 10rem;">{{ hours }}</span> 小时 <span style="margin: 0 10rem;"> {{ mins }}</span> 分钟
  内完成试卷</div>
        
        </div>
        <div v-else style="display: flex; margin-top: 39rem; ">
          <div style="margin-right: 166rem;">是否设置做卷时间</div>
          <div style="margin-top: 4rem;"><el-checkbox-group v-model="checked"
                               @change="handleChange">
              <el-checkbox label="true" style="margin-right: 116rem;">是</el-checkbox>
              <el-checkbox label="false">否</el-checkbox>

            </el-checkbox-group></div>
        </div>
        <p v-if="checked[0] == 'true'"
           style="margin-top: 28rem; display: flex; justify-content: flex-end; gap: 24px;margin-right: 131rem;">
          <el-input v-model="examTime"
                    placeholder=""
                    style="width: 10%;"
                    @change="changeTime" />
          小时
          <el-input v-model="examTime1"
                    placeholder=""
                    style="width: 10%;"
                    @change="changeTime" />
          分钟
        </p>
      </div>
       <div class="text_warp1" v-if=" this.$route.query.type==19 ">
        <p style="text-align: center;font-weight: 600;">推送设置 </p>
        <div   style="display: flex;justify-content: space-between;font-weight: 400;
font-size: 24rem; margin-top: 39rem;">
          <div >设置导出题目类型  </div>
           <div style="margin-top: 4rem;"><el-checkbox-group v-model="checkedType1"
                               @change="handleChangeType1">
              <el-checkbox label="false" style="margin-right: 101rem;">原题</el-checkbox>
              <el-checkbox label="true">原题加推送题</el-checkbox>

            </el-checkbox-group></div>
        
        </div>
      </div>
      <div class="btn_warp">
        <div @click="back">
          取消
        </div>
        <div @click="handleClose">
          开始答题
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      examTime: "",
      examTime1: "",
      checkedType: ["false"],
       checkedType1: ["false"],
      checked: ["false"]   // 最多一个元素
    }
  },
  computed: {
  hours() {
    const total = Number(JSON.parse(this.$route.query.form).paper_duration || 0);
    return Math.floor(total / 60);
  },
  mins() {
    const total = Number(JSON.parse(this.$route.query.form).paper_duration || 0);
    return total % 60;
  }
},
  methods: {
    handleChange (val) {
      // 互斥：只保留最后勾选的
      if (val.length > 1) {
        this.checked = [val[val.length - 1]]
      }
    },
    handleChangeType(val) {
      // 互斥：只保留最后勾选的
      if (val.length > 1) {
        this.checkedType = [val[val.length - 1]]
      }
    },
       handleChangeType1(val) {
      // 互斥：只保留最后勾选的
      if (val.length > 1) {
        this.checkedType1 = [val[val.length - 1]]
      }
    },
    changeTime () {
      let time = this.examTime * 3600 + this.examTime1 * 60
      window.localStorage.setItem('exam_time_left', time)
    },
    handleClose () {
      this.dialogVisible = false
 
window.localStorage.setItem('checkedType', this.checkedType[0]     == 'true' ? 1 : 0)
 window.localStorage.setItem('checkedType1', this.checkedType1[0]     == 'true' ? 1 : 0)
      this.$parent.showPaper()
    },
    back () {
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input--medium{
  font-size: 24rem;
}
::v-deep .el-dialog  {
  border-radius: 32rem !important;

}
::v-deep .el-dialog__header {
  padding-top: 32rem;
}
::v-deep .el-checkbox__label {
  font-size: 24rem;
}
::v-deep .el-checkbox__input {
  line-height: 2;
}

::v-deep .el-checkbox__inner {
  width: 24rem;
  height: 24rem;
}
.text_warp {
  word-break: break-all;
  font-weight: 400;
  color: #333333 !important;
  line-height: 36rem;
  font-size: 24rem;
  padding: 40rem;
  padding-top: 32rem;
}
.text_warp1 {
  word-break: break-all;
  font-weight: 400;
  color: #333333 !important;
  line-height: 33rem;
  font-size: 24rem;
  padding: 40rem;
  padding-top:8rem;
}
.btn_warp {
  width: 100%;
  height: 70rem;
  border-top: 1rem solid #e5e5e5;
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24rem;
    &:nth-child(1) {
      font-weight: bold;
      color: #999999;
      border-right: 1rem solid #e5e5e5;
    }
    &:nth-child(2) {
      font-weight: bold;
      color: #2196f3;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
  padding-bottom: 70rem;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  display: none;
}
::v-deep .el-dialog__header {
  font-size: 18rem;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
::v-deep .el-dialog__title {
  color: #333333;
  font-weight: 600;
  font-size: 24rem;
  line-height: 33rem;
}
::v-deep .el-dialog {
  border-radius: 32rem;
  position: absolute;
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 12rem !important;
  // height: 892rem;
}
::v-deep .el-checkbox__inner::after{
 
   
    height: 15px;
    left: 7px;
    width: 7px;
   
}
</style>